// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"bd91a542","767":"a04c366a"}[chunkId] + ".chunk.js";
};